import axios from '@/axios.js'
import Vue from 'vue'
export default {
  
  fetchUsersReport ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/reports/allUsers')
        .then((response) => {
          commit('SET_USERS_REPORT', response.data.data.list)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchUserData ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get('/reports/userData/'+ userId)
        .then((response) => {
          commit('SET_USER_DATA', response.data.data.list)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }  
}
